import {MISC, NATURE_CYCLE, O2C, P2P} from "../constants/document"

interface CycleRouteConfig {
    /** Route identifier (key `name` in buildNatureRoutes + i18n key `menu:<name>`), no space/accent. */
    name: string
    /** URL path segment (kebab-case), used in the route URL and the `:cycle` URL param. */
    slug: string
    /** Escaped nature code prefix, used to match document types of the cycle. */
    codePrefix: string
    /** Optional flag: route exposes `keyWords`. */
    hasKeyWords?: boolean
}

/**
 * Mapping each nature cycle to its route name, URL slug and nature code prefix.
 */
export const NATURE_CYCLE_ROUTE: Record<string, CycleRouteConfig> = {
    O_2_C: {name: "Ventes", slug: "ventes", codePrefix: O2C, hasKeyWords: true},
    P_2_P: {name: "Achats", slug: "achats", codePrefix: P2P},
    MISC: {name: "AutresDocuments", slug: "autres-documents", codePrefix: MISC},
    REPORT: {name: "Declarations", slug: "declarations", codePrefix: NATURE_CYCLE.REPORT}
}

/** Get the route name (key `name` in buildNatureRoutes) corresponding to a nature cycle. */
export const getCycleRouteName = (cycle: string): string => NATURE_CYCLE_ROUTE[cycle]?.name ?? ""

/** Get the URL slug corresponding to a nature cycle. */
export const getCycleRouteSlug = (cycle: string): string => NATURE_CYCLE_ROUTE[cycle]?.slug ?? ""
